"use strict";

/**
 * Define the output of this file. The output of CSS and JS file will be auto detected.
 *
 * @output css/style.bundle
 */

// demo styles
require("../../src/assets/sass/style.scss");